// WalletConnect session cleanup — purge orphaned sessions from localStorage
// Fixes: "User disapproved requested methods" (stale namespace) and
// "No matching key. session topic doesn't exist" (orphaned topic in keychain)

const WC_STORAGE_PREFIX = 'wc@2:';

export const clearWcSessions = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;

  const keysToRemove: ReadonlyArray<string> = Object.keys(localStorage)
    .filter((key) => key.startsWith(WC_STORAGE_PREFIX));

  keysToRemove.forEach((key) => localStorage.removeItem(key));
};

export const clearStaleWcOnMount = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;

  const sessionKey = Object.keys(localStorage)
    .find((key) => key.startsWith(WC_STORAGE_PREFIX) && key.includes('session'));

  if (sessionKey === undefined) return;

  try {
    const raw = localStorage.getItem(sessionKey);
    if (raw === null) return;
    const sessions: ReadonlyArray<unknown> = JSON.parse(raw);
    if (!Array.isArray(sessions) || sessions.length === 0) return;

    // Stale sessions exist from a previous page load — clear everything
    // so the next connection starts fresh without namespace conflicts
    clearWcSessions();
  } catch {
    // Corrupted storage — clear it all
    clearWcSessions();
  }
};
